import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIncident = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 20 20",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M11.093 1.269c.51 0 .885.5.755 1.005L10.46 6.596l3.757-1.066c.602 0 .976.67.674 1.199l-5.73 11.186a.778.778 0 0 1-.677.4.794.794 0 0 1-.758-.982l1.5-7.541-3.864 1.065a.795.795 0 0 1-.774-.906l2.083-7.99a.789.789 0 0 1 .774-.692h3.647Z" })
});
export default SvgIncident;
